import React from 'react'
import ReactDOM from 'react-dom'
import Fader from 'react-fader'
import mqtt from 'mqtt'
import {CSSTransitionGroup} from 'react-transition-group'
import './graphic/style.sass'
import {loadJSON} from './jsonLoader.js'
import StartScreen from './components/startScreen.js'
import ManualScreen from './components/manualScreen.js'
import SlotScreen from './components/slotScreen.js'
import SplitScreen from './components/splitScreen/splitScreen.js'
import GlossaryScreen from './components/glossaryScreen.js'
import PV from './components/presentationReferral/presentationReferral.js'
// import PV from './components/finalQuestionScreen.js'

let data
let client //= mqtt.connect(config.mqtt)

class App extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			screenID: -2,  // -2 default
			userID: undefined,
			rotateIsSet: false,
			dataLoaded: false,
			lang: 'de',
			gender_id: undefined, //SET to DEFAULT: undefined
			gender: undefined,
			nationality: undefined, //SET to DEFAULT: undefined
			profession: undefined, //SET to DEFAULT: undefined
			religion: undefined, //SET to DEFAULT: undefined
			relationship: undefined,
			hobby: undefined,
			pet: undefined,
			machineData: undefined,
			fakeMachineData: true
		}
	}

	componentDidMount() {
		loadJSON(`de/fields.json`).then(content => {
			data = content
			config.assetPath = 'de/'
			this.setState({
				dataLoaded : true
			}, () => {
				console.log("data loaded and dataLoaded state now: " + this.state.dataLoaded)
				this.generateFakeData()
			})
		}, err => {
			console.log("The data can't be loaded")
		})
	}

	generateFakeData = () => {
		console.log('generating Data')
		let symbolsArray = [this.getRandomInt(6),this.getRandomInt(3),this.getRandomInt(6),this.getRandomInt(7)]
		this.getPropertiesFromMachine(symbolsArray)
		console.log(JSON.stringify(symbolsArray));
		this.setState({
			machineData: symbolsArray
		})
	}

	getRandomInt = max => {
		return Math.floor(Math.random() * Math.floor(max));
	}

	getPropertiesFromMachine = propertiesArray => {
		for(let element in propertiesArray){
			switch(element){
			case '0':
				this.getPropertiesfile('nationalities', propertiesArray[element], 'nationality')
				break
			case '1':
				const propertiesData = data.fields.properties
				for(let propertyElement of propertiesData['genders']){
					let newArray = propertyElement.field.id.split(',')
					for(let id of newArray){
						if(propertiesArray[element] == id){
							this.setProperties('gender', propertyElement)
							this.setState({
								gender_id: propertyElement.field.property
							})
						}
					}
				}
				break
			case '2':
				this.getPropertiesfile('professions', propertiesArray[element], 'profession')
				break
			case '3':
				this.getPropertiesfile('religions', propertiesArray[element], 'religion')
				break
			}
		}
		if(this.state.screenID === -1){
			this.setNextScreen()
		}
	}
	getPropertiesfile = (propertyType, machineproperty, property) => {
		const propertiesData = data.fields.properties
		for(let element of propertiesData[propertyType]){
			let newArray = element.field.id.split(',')
			for(let id of newArray){
				if(machineproperty == id){
					this.setProperties(property, element)
				}
			}
		}
	}

	setProperties = (state, value) => {
		let newValue = value
		this.setState({
			[state]: newValue,
		}, () => {
			console.log(newValue.field);
		})
	}

	handleButtonClick = (e) => {
		if(e){
			let currentClassList = e.currentTarget.classList
			currentClassList.add('button--active')
		}
		this.setNextScreen()
	}

	returnButtonClick = (e) => {
		if(e){
			let currentClassList = e.currentTarget.classList
			currentClassList.add('button--active')
		}
		this.generateFakeData()
		let _this = this
		setTimeout(function(){ 
			_this.setState({
				screenID : -2,
			}) 
		}, 300)
	}

	setNextScreen = () => {
		const {screenID} = this.state
		let newScreenID = screenID + 1
		// if(newScreenID === 2 && !data.fields.screen_6){
		// 	newScreenID = screenID + 2
		// }
		let _this = this

		setTimeout(function(){ 
			_this.setState({
				screenID : newScreenID,
			}) 
		}, 300)
	}

	render() {
		const {
			screenID,
			userID,
			lang,
			dataLoaded,
			gender_id,
			gender,
			nationality,
			profession,
			religion,
			relationship,
			hobby,
			pet,
			machineData,
			fakeMachineData
		} = this.state
		if(dataLoaded == true){
			const fieldsData = data.fields
			const identifier = data.identifier
			const pvEndData = data.dependencies[0].fields

			let pvOptionsHash = {
				gender: gender,
				nationality: nationality,
				profession: profession,
				religion: religion
			}
			// get current screen type
			switch(screenID){
			case -2:
				return( 
					<Fader fadeOutTransitionDuration={300}> 
						<StartScreen
							key={screenID}
							handler={this.handleButtonClick} 
							data={fieldsData}
							lang={lang}
						/>
					</Fader>
				)
			case -1:
				return(
					<Fader 
						fadeInTransitionDuration={300}
						fadeOutTransitionDuration={300}> 
						<ManualScreen
							key={screenID}
							handler={this.handleButtonClick} 
							data={fieldsData}
							lang={lang}
							client={client}
							fakeMachineData={fakeMachineData}
						/>
					</Fader>
				)
			case 0: 
				return(
					<Fader 
						fadeInTransitionDuration={300}
						fadeOutTransitionDuration={300}> 
						<SlotScreen
							key={screenID}
							handler={this.handleButtonClick} 
							data={fieldsData}
							machineData={machineData}
							gender_id={gender_id}
							gender={gender}
							nationality={nationality}
							profession={profession}
							religion={religion}
							lang={lang}
						/>
					</Fader>
				)
			case 1:
				return(
					<Fader
						fadeInTransitionDuration={300}
						fadeOutTransitionDuration={300}> 
						<SplitScreen
							key={screenID}
							handler={this.handleButtonClick} 
							data={fieldsData}
							gender={gender}
							nationality={nationality}
							profession={profession}
							religion={religion}
							relationshipID={relationship}
							hobbyID={hobby}
							petID={pet}
							setProperties={this.setProperties}
							lang={lang}
							gender_id={gender_id}
						/>
					</Fader>
				)
			case 2:
				return(
					<Fader
						fadeInTransitionDuration={300}
						fadeOutTransitionDuration={300}> 
						<CSSTransitionGroup
							transitionName="background"
							transitionAppear={true}
							transitionAppearTimeout={1100}
							transitionEnterTimeout={1100}
							transitionLeaveTimeout={1100}>
							<PV
								pvData={fieldsData.pv}
								pvEndData={pvEndData}
								pvOptionsHash={pvOptionsHash}
								lang={lang}
								client={client}
								userID={userID}
								identifier={identifier}
								returnHandler={this.returnButtonClick}
							/>
						</CSSTransitionGroup>
					</Fader>
				)
			}
		}
		return(
			<div>{'App is loading'}</div>
		)
	}
}

ReactDOM.render(<App/>, document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js